import gql from 'graphql-tag';

const REFRESH_ORG_SUMMARY = gql`
  mutation refreshOrgSummary($orgID: ID!) {
    refreshOrgSummary(where: { id: $orgID })
  }
`;

export default REFRESH_ORG_SUMMARY;
